import { DialogController } from 'aurelia-dialog';
import { EventAggregator } from 'aurelia-event-aggregator';
import { inject } from "aurelia-framework";
import { activationStrategy, Router } from 'aurelia-router';

@inject(DialogController, Router, EventAggregator)
export class CustomPrompt {
	router: Router;
	controller: DialogController;
	eventAggregator: EventAggregator;
	title: any;
	canContinue: any;
	confirm: any;
	cancel: any;
	viewModelPath: any;
	viewModelModel: any;
	dialogSize: any;
	confirmAndFresh: any;
	viewModel: any;

	determineActivationStrategy() {
		return activationStrategy.replace; //replace the viewmodel with a new instance
		// or activationStrategy.invokeLifecycle to invoke router lifecycle methods on the existing VM
		// or activationStrategy.noChange to explicitly use the default behavior
	}
	constructor(controller: DialogController, router: Router, eventAggregator: EventAggregator) {
		this.router = router
		this.controller = controller;
		this.eventAggregator = eventAggregator;
	}

	message = "";

	activate(data) {
		this.title = data.title;
		this.message = data.message;
		this.canContinue = data.canContinue;
		this.confirm = data.confirm;
		this.cancel = data.cancel;
		this.viewModelPath = data.viewModelPath;
		this.viewModelModel = data.viewModelModel;
		this.dialogSize = data.dialogSize;
		this.confirmAndFresh = data.confirmAndFresh;
	}

	//TODO: Chris - add computedFrom
	get dynamicTitle() {
		if (this.viewModel && this.viewModel.currentViewModel && this.viewModel.currentViewModel.title) {
			return this.viewModel.currentViewModel.title;
		}
		return this.title;
	}

	save() {
		this.controller.ok();
	}

	close() {
		this.controller.cancel();
	}

	//TODO: Chris - add computedFrom
	get dialogCss() {
		if (this.dialogSize == 'lg')
			return "modal-dialog dialog-lg";
		if (this.dialogSize == 'sm')
			return "modal-dialog dialog-sm";
		if (this.dialogSize == 'md')
			return "modal-dialog dialog-md";
		return "modal-dialog";
	}
}

export class PromptModel {
	title: any;
	message: any;
	canContinue: any;
	confirm: any;
	cancel: any;
	dialogSize: any;
	viewModelPath: any;
	viewModelModel: any;
	confirmAndFresh: any;

	constructor(title, message, canContinue, confirm, cancel, dialogSize, viewModelPath, viewModelModel, confirmAndFresh) {
		this.title = title;
		this.message = message;
		this.canContinue = canContinue;
		this.confirm = confirm;
		this.cancel = cancel;
		this.dialogSize = dialogSize;
		this.viewModelPath = viewModelPath;
		this.viewModelModel = viewModelModel;
		this.confirmAndFresh = confirmAndFresh;
	}
}
